import React from "react";

//Pages Component
import AboutSection from "../components/aboutSection";
import ServicesSection from "../components/ServicesSection";
import FaqSection from "../components/FaqSection";

///Animation
import { motion } from "framer-motion";
import { pageAnimation } from "../animation";

const AboutUs = () => {
  return (
    <motion.div
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
    >
      <AboutSection />
      <ServicesSection />
      <FaqSection />
    </motion.div>
  );
};

export default AboutUs;
